import BaseDateData from './BaseDateData'

export default {
  extends: BaseDateData,
  data () {
    return {
      query: {
        siteIds: [],
        isAuditCompleted: false // finished
      },
      currentQuery: Object.freeze({}),
      dataList: Object.freeze([]),
      selectedNames: []
    }
  },
  computed: {
    deviceCategories: () => [[0], 0],
    minSiteSelectNumber: () => 1,
    sites () {
      let profileSites = JSON.parse(JSON.stringify(this.profileSites))
      let profileSiteDeviceMap = this.profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let siteDevices = map[siteId]

        if (!Array.isArray(siteDevices)) {
          siteDevices = map[siteId] = []
        }

        siteDevices.push(siteDevice)

        return map
      }, {})

      profileSites.forEach(site => {
        site.devices = profileSiteDeviceMap[site.id] || []
      })

      return profileSites
    },
    filterSites () {
      // let [deviceCategoryNum, compareDeviceCategoryNum] = this.deviceCategories
      //
      // return this.sites.reduce((list, site) => {
      //   let siteDevices = site.devices
      //   let deviceCategory = siteDevices.reduce((count, siteDevice) => count | siteDevice.categoryId, 0)
      //
      //   if ((deviceCategory & deviceCategoryNum) >= compareDeviceCategoryNum) {
      //     list.push({
      //       id: site.id,
      //       name: site.name,
      //       devices: siteDevices.filter(siteDevice => siteDevice.categoryId & deviceCategoryNum)
      //     })
      //   }
      //
      //   return list
      // }, [])

      let [deviceCategoryIds, compareDeviceCategoryLen] = this.deviceCategories
      let deviceCategoryMap = deviceCategoryIds.reduce((map, deviceCategoryId) => {
        map[deviceCategoryId] = true
        return map
      }, {})

      return this.sites.reduce((list, site) => {
        let siteDevices = site.devices

        if (compareDeviceCategoryLen > 0) {
          siteDevices = siteDevices.filter(siteDevice => deviceCategoryMap[siteDevice.categoryId])
          let deviceCategoryIds = [...new Set(siteDevices.map(siteDevice => siteDevice.categoryId))]

          if (deviceCategoryIds.length < compareDeviceCategoryLen) {
            return list
          }
        }

        list.push({
          id: site.id,
          name: site.name,
          devices: siteDevices
        })

        return list
      }, [])
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    canNotSearch () {
      return this.query.siteIds.length === 0
    }
  },
  methods: {
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length > 0) {
        let {query: {siteIds}} = this

        if (siteIds.length === 0) {
          siteIds.push(...filterSites.slice(0, this.minSiteSelectNumber).map(site => site.id))
        }

        this.afterSetSiteIds()
      }
    },
    afterSetSiteIds () {
      this.setCurrentQuery()
      this.getData()
    },
    setCurrentQuery () {
      this.currentQuery = Object.freeze(JSON.parse(JSON.stringify(this.query)))
    },
    getData () {
      this.changeLoadStatus(true)

      this.$api.Data.getHistoryData(this.currentQuery).then(dataList => {
        this.tmpList = dataList
        this.formatData()
        this.renderData()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatData () {

    },
    renderData () {
      setTimeout(() => {
        let dataRenders = this.getDataRenders()

        if (dataRenders) {
          dataRenders.forEach(dataRender => dataRender.render())
        }
      }, 0)
    },
    onAuditCompletedChanged () {
      let {query} = this
      if (query.isAuditCompleted === 'isFuse') {
        query.isFuse = true
        delete query.isAuditCompleted
      } else {
        query.isFuse = false
      }
      this.afterSetSiteIds()
    },
    onSearchBtnClick () {
      this.afterSetSiteIds()
    },
    getDataRenders () {
      return this.$refs['data-renders']
    }
  },
  watch: {
    filterSites (newVal) {
      this.setSiteIds()
    }
  },
  created () {
    this.setSiteIds()
  }
}



// WEBPACK FOOTER //
// ./src/views/BaseSiteData.js